module.exports = __webpack_public_path__ + "img/comp_charles.41ee37f9.png";